/**
 * 将Date()格式数据转换为'XXXX-XX-XX'
 * @example ‘new Date()' Date类型
 * @return  '2018-01-01'     String类型
 */
export function getYearMonthDay(date) {
  let month = "0" + (date.getMonth() + 1);
  let day = "0" + date.getDate();

  return date.getFullYear() + '-' + month.substring(month.length - 2) + '-' + day.substring(day.length - 2);
}
export function getHourMinutes(date){
  let hour="0" +date.getHours();
  let minutes="0" + date.getMinutes();
  return hour.substring(hour.length - 2) + ':' + minutes.substring(minutes.length - 2);
}



// WEBPACK FOOTER //
// ./src/common/js/getYearMonthDay.js